











































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName } from '../../core/utils';

@Component({
    components: {}
})
export default class Breadcrums extends Vue {
    @Prop() elments: any;
    listItems: any = [];
    dialog: boolean = false;
    resolve: any = null;
    reject: any = null;
    message: any = null;
    title: any = null;
    options: any = {
        color: 'orange lighten-2',
        width: 400,
        zIndex: 200,
        noconfirm: false
    };

    open(title, message, options?) {
        this.dialog = true;
        this.title = title;
        this.message = message;
        this.options = Object.assign(this.options, options);
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    mounted() {
        this.listItems = this.elments;
    }

    agree() {
        this.resolve(true);
        this.dialog = false;
    }

    cancel() {
        this.resolve(false);
        this.dialog = false;
    }

    async delRecord(item) {
        if (await this.open('Mensaje de confirmación', '¿Está seguro que desea ir a: <b>' + item.text + '</b>?')) {
            this.triggerAction(item.action);
        }
    }

    triggerAction(action) {
        if (action !== null) {
            if (action === 'back') {
                this.$emit('close-modal');
            } else if (action === 'goToEcuList') {
                EventBus.$emit(TypeEventBus.NORMS_ECU_DIALOG_CLOSE_CHILDREN_COMPONENTS);
            } else if (action === 'goToEcuDialog') {
                EventBus.$emit(TypeEventBus.NORMS_ECU_DIALOG_VISIBLE);
            } else if (action === 'goToFrameDialog') {
                EventBus.$emit(TypeEventBus.NORMS_FRAMES_DIALOG_VISIBLE);
            } else if (action === 'previewEcu') {
                EventBus.$emit(TypeEventBus.NORMS_ECU_DIALOG_PREVIEW_ECU);
            } else if (action === 'modifyEcu') {
                EventBus.$emit(TypeEventBus.NORMS_ECU_DIALOG_MODIFY_ECU);
            } else if (action === 'goToFramesList') {
                EventBus.$emit(TypeEventBus.NORMS_FRAMES_DIALOG_CLOSE_CHILDREN_COMPONENTS);
            } else if (action === 'goToDatabaseList') {
                EventBus.$emit(TypeEventBus.NORMS_FRAMES_DIALOG_CLOSE_CHILDREN_COMPONENTS);
            } else if (action === 'goToParameterDialog') {
                EventBus.$emit(TypeEventBus.NORMS_PARAMETER_DIALOOG_CLOSE_CHILDREN_COMPONENTS);
            } else if (action === 'goToVarDefinitionDialog') {
                EventBus.$emit(TypeEventBus.NORMS_VAR_DEFINITION_DIALOOG_CLOSE_CHILDREN_COMPONENTS);
            } else if (action === 'goToCreateVarClassificationList') {
                EventBus.$emit(TypeEventBus.NORMS_VARIABLE_CLASSIFICATION_DIALOG_CLOSE_CHILDREN_COMPONENT);
            }
        }
    }
}
